import Index from './Index'

export default [
  {
    path: '/calculator',
    name: 'calculator',
    component: Index,
    meta: {
      auth: true,
      bodyClass: 'navbar-top',
      breadcrumb: 'Calculator'
    },
    children: [
    ]
  }
]
